import { Component, OnInit } from '@angular/core';
import { NoficationType, NotificationBanner } from '../../models/notification-class.enum';
import { CVA_CONSTANTS } from '../../util/constants';
import { CustomLoginService } from '@privatelib/ngx18-authz-dev';
import { LoginService } from '../../services/login/login.service';

@Component({
    standalone: false,
    selector: 'cva-notification-banner',
    templateUrl: './notification-banner.component.html',
    
})
export class NotificationBannerComponent implements OnInit {
  notification!: NotificationBanner | undefined;
  isValidtyChecked = false;

  constructor(
    private readonly  authorize: CustomLoginService,
    private readonly  loginService: LoginService
  ){}
  
  ngOnInit(): void {
    this.loginService.loggedIn$.subscribe({
      next: (isLoggedIn) => {
        if(isLoggedIn && !this.isValidtyChecked) {
          this.isValidtyChecked = true;
          this.checkUserValidity();
        }
      }
    });
  }
   
  async checkUserValidity(){
    const response = await this.authorize.getValidity();
    if(!response) return;
    const {days_to_expiry, notify} = response.body.validity;
    if(days_to_expiry <= notify){
      let message = CVA_CONSTANTS.MESSAGE.ACCOUNT_EXPIRY_REMINDER;
      message = message.replace(/{count}/g, days_to_expiry);
      this.notification = {
        type: NoficationType.WARNING,
        icon:'warning',
        message: message
      }
    }
  }
}
